import React from 'react';
import { showNotification as showNotificationAction } from 'ra-core';
import { withStyles, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { FileCopyOutlined } from '@material-ui/icons';
import { connect } from 'react-redux';
const styles = {
  field: {
    width: '100%',
    maxWidth: '512px',
    '&& > div:before': {
      borderBottomStyle: 'solid'
    }
  }
}

const CopyToClipboardField = ({classes, name, value = "", showNotification}) => {
  const copyText = (value, name) => {
    navigator.clipboard.writeText(value)
      .then(() => {
        showNotification(`${name} copied to clipboard`)
      })
      .catch((error) => { showNotification(`Copy failed! ${error}`) })
  };
  return (
    <TextField
      className={classes.field}
      label={name}
      value={value}
      onChange={()=>{}}
      disabled

      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={`Click to copy ${name}`}
              onClick={()=>copyText(value, name)}
            >
              <FileCopyOutlined />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default connect(null, {
  showNotification: showNotificationAction
})(withStyles(styles)(CopyToClipboardField));
